import { ThemeUICSSObject } from '@apia/theme';

const mainEnvironmentsSelector: ThemeUICSSObject = {};

export default mainEnvironmentsSelector;
